// getters
const papeleriaRequests = state => state.papeleriaRequests

export default {
  papeleriaRequests
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/requests/getters.js